import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Router } from '@angular/router';
import { fuseAnimations } from '../../../../../../core/animations';
import { AuthenticationService } from '../../../../../services/authentication/authentication.service';
import { DivisionService } from '../../../../../services/divisions/division.service';
import { ShiftService } from '../../../../../services/shifts/shift.service';
import { SweetAlertService } from '../../../../../services/sweet-alert/sweet-alert.service';
import { FormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'fuse-add-edit-divisionr',
    templateUrl: 'add-edit-division.component.html',
    styleUrls: ['./add-edit-division.component.scss'],
    animations: fuseAnimations
})
export class AddEditDivisionComponent implements OnInit, OnDestroy {
    @BlockUI('tracker') blockUIList: NgBlockUI;
    public contador = 0;
    formGroup;
    divisionFormControl;
    curriculumFormControl;

    ngOnDestroy(): void {
    }

    ngOnInit(): void {
        console.log('data>>>>>>>>>', this.data);
        this.contador = 0;

    }

    constructor(private authenticationService: AuthenticationService,
                @Inject(MAT_DIALOG_DATA) public data: any,
                public dialogRef: MatDialogRef<AddEditDivisionComponent>,
                public dialog: MatDialog,
                public divisionService: DivisionService,
                public shiftService: ShiftService,
                private router: Router,
                private fb: FormBuilder,
                private sweetAlertService: SweetAlertService) {
        this.initializeFormControlValidators();
    }

    initializeFormControlValidators() {
        this.formGroup = this.fb.group({
            divisionFormControl: ['', [Validators.required]],
            curriculumFormControl: ['', [Validators.required]]
        });
    }

    checkValidationErrors() {
        setTimeout(() => {
        }, 20);
    }

    save() {
        if (this.data.mode === 'new') {
            this.dialogRef.close(this.data);
        } else {
            console.log('editar');
            // guardar primero
            this.dialogRef.close(this.data);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/schoolyear/add-edit-division/add-edit-division.component.ts